//logo
import gstw from "assets/img/logo/gstwhite.png";
import gstb from "assets/img/logo/gstdark.png";
import cinw from "assets/img/logo/cinwhite.png";
import cinb from "assets/img/logo/cindark.png";
import dinw from "assets/img/logo/dinwhite.png";
import dinb from "assets/img/logo/dindark.png";
import panw from "assets/img/logo/panwhite.png";
import panb from "assets/img/logo/pandark.png";
import upiw from "assets/img/logo/upiwhite.png";
import upib from "assets/img/logo/upidark.png";
import msmew from "assets/img/logo/msmewhite.png";
import msmeb from "assets/img/logo/msmedark.png";
import iecb from "assets/img/logo/iecdark.png";
import iecw from "assets/img/logo/iecwhite.png";
import ngow from "assets/img/logo/ngowhite.png";
import osintb from "assets/img/logo/osintdark.png";
import osintw from "assets/img/logo/osintwhite.png";
import madw from "assets/img/logo/madwhite.png";
import madb from "assets/img/logo/maddark.png";
import Factbytew from "assets/img/logo/factbytewhite.png";
import Factbyteb from "assets/img/logo/factbyteblack.png";
import mobile360w from "assets/img/logo/mobile360white.png";
import mobile360d from "assets/img/logo/mobile360dark.png";
import bankd from "assets/img/logo/bankdark.png";
import bankw from "assets/img/logo/bankwhite.png";
import deshboardw from "assets/img/logo/deshboardwhite.png";
import Profile from "assets/img/profile/demo.png";
import whatsApp from "assets/img/socialMediaIcon/whatsApp.webp";
import viewcaller from "assets/img/socialMediaIcon/viewcaller.webp";
import hiya from "assets/img/socialMediaIcon/hiya.webp";
import callapp from "assets/img/socialMediaIcon/callapp.webp";
import tc from "assets/img/socialMediaIcon/tc.webp";
import getcontact from "assets/img/socialMediaIcon/getcontact.webp";
import skype from "assets/img/socialMediaIcon/skype.webp";
import telegram from "assets/img/socialMediaIcon/telegram.webp";
import viber from "assets/img/socialMediaIcon/viber.webp";
import pluto from "assets/img/socialMediaIcon/pluto.webp";
import tamtam from "assets/img/socialMediaIcon/tamtam.webp";
import botim from "assets/img/socialMediaIcon/botim.webp";
import imo from "assets/img/socialMediaIcon/imo.webp";
import eyes from "assets/img/socialMediaIcon/eyes.webp";
import eyecon from "assets/img/socialMediaIcon/eyecon.webp";
import drupe from "assets/img/socialMediaIcon/drupe.webp";
import pdf from "assets/img/logo/pdf.png";
import pdfb from "assets/img/logo/pdfb.png";
import profile from "assets/img/profile/profile.jpg";
import drive from "assets/img/logo/drive.png";
import mca from "assets/img/logo/mca.png";
import iob from "assets/img/logo/iob.jpg";
import logoloader from "assets/img/logo/Logo-Animation-1.webp";




const gstStatus = [
  { name: "Provisional", value: "Provisional" },
  { name: "Active pending Verification", value: "Active pending Verification" },
  { name: "Cancelled", value: "Cancelled" },
  { name: "Inactive", value: "Inactive" },
  { name: "Active", value: "Active" },
  { name: "Suspended", value: "Suspended" },
  {
    name: "Cancelled on application of Taxpayer",
    value: "Cancelled on application of Taxpayer",
  },
  { name: "Suspended", value: "Suspended" },
];

const pdfdata =
  ["/view/cindetail", "/view/gstdetail", "/view/msmedetail", "/view/pandetail", "/view/dindetail"];

const CompanyStatus = [
  {
    name: "Converted to CMP and Dissolved",
    value: "Converted to CMP and Dissolved",
  },
  { name: "Not define", value: "Not define" },
  { name: "Converted to LLP", value: "Converted to LLP" },
  { name: "Dissolved", value: "Dissolved" },
  { name: "Active", value: "Active" },
  {
    name: "Converted and Dissolved",
    value: "Converted and Dissolved",
  },
  {
    name: "Dissolved (Liquidated)",
    value: "Dissolved (Liquidated)",
  },
  { name: "Inactive", value: "Inactive" },
  { name: "Under Liquidation", value: "Under Liquidation" },
  { name: "Under CIRP", value: "Under CIRP" },
  {
    name: "Dissolved under section ()",
    value: "Dissolved under section ()",
  },
  {
    name: "Not available for efiling",
    value: "Not available for efiling",
  },
  { name: "Strike Off", value: "Strike Off" },
  {
    name: "Dissolved under section 54",
    value: "Dissolved under section 54",
  },
  {
    name: "Under process of striking off",
    value: "Under process of striking off",
  },
  {
    name: "Inactive for e-filing",
    value: "Inactive for e-filing",
  },
  { name: "Unlisted", value: "Unlisted" },
  {
    name: "Dissolved under section",
    value: "Dissolved under section",
  },
  {
    name: "Dormant under section 455",
    value: "Dormant under section 455",
  },
  {
    name: "Strike Off-AwaitingPublication",
    value: "Strike Off-AwaitingPublication",
  },
  {
    name: "Dissolved under section 59(8)",
    value: "Dissolved under section 59(8)",
  },
  { name: "Amalgamated", value: "Amalgamated" },
  {
    name: "Dormant under section",
    value: "Dormant under section",
  },
  {
    name: "Converted to LLP and Dissolved",
    value: "Converted to LLP and Dissolved",
  },
];
const ListingStatus = [
  { name: "Active", value: "Active" },
  { name: "Listed", value: "Listed" },
  { name: "Unlisted", value: "Unlisted" },
];

const Classification = [
  { name: "Foreign", value: "Foreign" },
  { name: "Private", value: "Private" },
  { name: "Public", value: "Public" },
  { name: "One Person Company", value: "One Person Company" },
  { name: "LLP", value: "LLP" },
];

const AuthorizedCapital = [
  { name: "Up to 1 Lakh", value: "1" },
  { name: "1 To 5 Lakh", value: "2" },
  { name: "5 To 15 Lakh", value: "3" },
  { name: "15 To 50 Lakh", value: "4" },
  { name: "50 To 200 Lakh", value: "5" },
  { name: "2 To 5 Crores", value: "6" },
  { name: "5 To 10 Crores", value: "7" },
  { name: "10 To 25 Crores", value: "8" },
  { name: "Above 25 Crores", value: "9" },
];

const PaidUpCapital = [
  { name: "Up to 1 Lakh", value: "1" },
  { name: "1 To 5 Lakh", value: "2" },
  { name: "5 To 15 Lakh", value: "3" },
  { name: "15 To 50 Lakh", value: "4" },
  { name: "50 To 200 Lakh", value: "5" },
  { name: "2 To 5 Crores", value: "6" },
  { name: "5 To 10 Crores", value: "7" },
  { name: "10 To 25 Crores", value: "8" },
  { name: "Above 25 Crores", value: "9" },
];
const color = {
  gst: "#5CB67C",
  cin: "#F9BA5D",
  din: "#60A5FA",
  pan: "#7D60D8",
  upi: "#C7B6F3",
  msme: "#EF4190",
  mobile: "#FF9A6C",
  iec: "#ED553B",
  osint: "#173F5F",
  mad: "#173F5F",
  bank: "#4169E1",
};

const SocialMediaImgLink = [
  { name: "WhatsApp", img: "https://play-lh.googleusercontent.com/bYtqbOcTYOlgc6gqZ2rwb8lptHuwlNE75zYJu6Bn076-hTmvd96HH-6v7S0YUAAJXoJN=w240-h480-rw" },
  { name: "Viewcaller", img: "https://play-lh.googleusercontent.com/y1tLD_SOT3oxCewMmvdqGCcHbGoDkSHhZdoeoRMajbvXaKkZJDfRX_-HU2ufAs-fOw=w240-h480-rw" },
  { name: "drupe", img: "https://cdn.fileplanet.com/anic/at/drupe-android.png" },
  { name: "Hiya", img: "https://play-lh.googleusercontent.com/0w58zzstVGY4rAbG2IBe7lSW4MHw79a-8v0SOEkHLc7tYe2E6XE6Kdawug6agWgbJg=w240-h480-rw" },
  { name: "Callapp", img: "https://play-lh.googleusercontent.com/RnobGoRbi_j1-tDiTDU5-om3ge6j12L3Ht0_2bDeh9JJAMPUD1yJ0rLxWCZkgjLY-g=w240-h480-rw" },
  { name: "tc", img: "https://play-lh.googleusercontent.com/VtP05VLAW1hdA8fyr5RGktM5LvuyUj4YagaAnfi9c_t3oyVv0iTAaZ1-6oC4za-bBEc=w240-h480-rw" },
  { name: "Getcontact", img: "https://play-lh.googleusercontent.com/HFxPZSWLMQDwl57wPs_iB7G0kia5Oi2zugYpd_SHGRuygChUd-zp9PqkD2_nNtVKzwY=s48-rw" },
  { name: "Skype", img: "https://play-lh.googleusercontent.com/-Udh2Qv4FyhP2uLfvNy27jzzXrrIfnDEi9kUqzhy8OQgGUcWXXud6nlg8UywECiRmME=w240-h480-rw" },
  { name: "Eyecon", img: "https://play-lh.googleusercontent.com/SQYXiEaByfBK8CJijvA8o-xUYY5MyzF1dYfWzQf19uHgxQQREAK7Px8sBtSg2h_O_Fw=w240-h480-rw" },
  { name: "Telegram", img: "https://play-lh.googleusercontent.com/ZU9cSsyIJZo6Oy7HTHiEPwZg0m2Crep-d5ZrfajqtsH-qgUXSqKpNA2FpPDTn-7qA5Q=w240-h480-rw" },
  { name: "viber", img: "https://play-lh.googleusercontent.com/xG_8ox1t_0CBsVMMZnCQr_CyYgc-9miU1JyYCzGlAorpcD3zqa9PR3zdbPNHRYAsWQ=s48-rw" },
  { name: "pluto", img: "https://play-lh.googleusercontent.com/yoROVSI4daVJXIonJTE6ss7CBrV5RXdF4mh__yoKYXo4fE3GTAPYF6teHHvWNQaPmRY=w240-h480-rw" },
  { name: "tamtam", img: "https://play-lh.googleusercontent.com/8po0vHlRbI-MTAm-qm71UaAJyj8woBVYXu-RSesruE1g3bSBlB5v3hdR-jOoMtbKqDw=w240-h480-rw" },
  { name: "imo", img: "https://play-lh.googleusercontent.com/0IdG4GLN7T73OrfRWwb3M1dyuFPmuAftPepnHS6p8qoTGvXXeHKHQY54-B8OXEbAZGI=w240-h480-rw" },
  { name: "botim", img: "https://play-lh.googleusercontent.com/01KJYHefo1hmyWDVUZPPpdWhlnFp-rUpV9WJkbUVyJ7F1pE3XoPwZgxkXgWqd0TTBus=w240-h480-rw" },
  { name: "eyes", img: "https://play-lh.googleusercontent.com/6uQ_fN7QjAreh5CzsBBONOqtSYpVFKzjSF-rhURbzxEavwXgRTIU3_J4warXTh_oD3k=w240-h480-rw" },
];
const SocialMediaImg = [
  { name: "WhatsApp", img: whatsApp },
  { name: "Viewcaller", img: viewcaller },
  { name: "drupe", img: drupe },
  { name: "Hiya", img: hiya },
  { name: "Callapp", img: callapp },
  { name: "tc", img: tc },
  { name: "Getcontact", img: getcontact },
  { name: "Skype", img: skype },
  { name: "Eyecon", img: eyecon },
  { name: "Telegram", img: telegram },
  { name: "viber", img: viber },
  { name: "pluto", img: pluto },
  { name: "tamtam", img: tamtam },
  { name: "imo", img: imo },
  { name: "botim", img: botim },
  { name: "eyes", img: eyes },
];

const stateNameMap = {
  DD: "Daman and Diu",
  OT: "Other Territory",
  CJ: "Central Jurisdiction",
  LK: "Lakshadweep",
  AN: "Andaman and Nicobar Islands",
  LD: "Ladakh",
  MZ: "Mizoram",
  SK: "Sikkim",
  NL: "Nagaland",
  MN: "Manipur",
  DNH: "Dadra and Nagar Haveli",
  AR: "Arunachal Pradesh",
  HP: "Himachal Pradesh",
  PY: "Puducherry",
  TR: "Tripura",
  ML: "Meghalaya",
  CH: "Chandigarh",
  GA: "Goa",
  JK: "Jammu and Kashmir",
  CT: "Chhattisgarh",
  UT: "Uttarakhand",
  JH: "Jharkhand",
  AS: "Assam",
  PB: "Punjab",
  OR: "Odisha",
  AP: "Andhra Pradesh",
  KL: "Kerala",
  TG: "Telangana",
  MP: "Madhya Pradesh",
  HR: "Haryana",
  BR: "Bihar",
  WB: "West Bengal",
  DL: "Delhi",
  RJ: "Rajasthan",
  KA: "Karnataka",
  TN: "Tamil Nadu",
  GJ: "Gujarat",
  MH: "Maharashtra",
  UP: "Uttar Pradesh"
};

const countChart = [
  { "categoryType": "GSTState", "category": "DD", "totalCount": 9962 },
  { "categoryType": "GSTState", "category": "OT", "totalCount": 77 },
  { "categoryType": "GSTState", "category": "CJ", "totalCount": 253 },
  { "categoryType": "GSTState", "category": "LK", "totalCount": 374 },
  { "categoryType": "GSTState", "category": "AN", "totalCount": 5598 },
  { "categoryType": "GSTState", "category": "LD", "totalCount": 7971 },
  { "categoryType": "GSTState", "category": "MZ", "totalCount": 7992 },
  { "categoryType": "GSTState", "category": "SK", "totalCount": 10035 },
  { "categoryType": "GSTState", "category": "NL", "totalCount": 10606 },
  { "categoryType": "GSTState", "category": "MN", "totalCount": 13952 },
  { "categoryType": "GSTState", "category": "DNH", "totalCount": 15696 },
  { "categoryType": "GSTState", "category": "AR", "totalCount": 18313 },
  { "categoryType": "GSTState", "category": "HP", "totalCount": 20145 },
  { "categoryType": "GSTState", "category": "PY", "totalCount": 24029 },
  { "categoryType": "GSTState", "category": "TR", "totalCount": 29877 },
  { "categoryType": "GSTState", "category": "ML", "totalCount": 30306 },
  { "categoryType": "GSTState", "category": "CH", "totalCount": 31578 },
  { "categoryType": "GSTState", "category": "GA", "totalCount": 44211 },
  { "categoryType": "GSTState", "category": "JK", "totalCount": 49171 },
  { "categoryType": "GSTState", "category": "CT", "totalCount": 173659 },
  { "categoryType": "GSTState", "category": "UT", "totalCount": 188742 },
  { "categoryType": "GSTState", "category": "JH", "totalCount": 198927 },
  { "categoryType": "GSTState", "category": "AS", "totalCount": 217578 },
  { "categoryType": "GSTState", "category": "PB", "totalCount": 249115 },
  { "categoryType": "GSTState", "category": "OR", "totalCount": 330816 },
  { "categoryType": "GSTState", "category": "AP", "totalCount": 393578 },
  { "categoryType": "GSTState", "category": "KL", "totalCount": 399973 },
  { "categoryType": "GSTState", "category": "TG", "totalCount": 504823 },
  { "categoryType": "GSTState", "category": "MP", "totalCount": 521303 },
  { "categoryType": "GSTState", "category": "HR", "totalCount": 541652 },
  { "categoryType": "GSTState", "category": "BR", "totalCount": 583634 },
  { "categoryType": "GSTState", "category": "WB", "totalCount": 707330 },
  { "categoryType": "GSTState", "category": "DL", "totalCount": 792515 },
  { "categoryType": "GSTState", "category": "RJ", "totalCount": 830974 },
  { "categoryType": "GSTState", "category": "KA", "totalCount": 983456 },
  { "categoryType": "GSTState", "category": "TN", "totalCount": 1101130 },
  { "categoryType": "GSTState", "category": "GJ", "totalCount": 1168218 },
  { "categoryType": "GSTState", "category": "MH", "totalCount": 1734405 },
  { "categoryType": "GSTState", "category": "UP", "totalCount": 1850678 }
];
const InfoByApiFichar = "Sorry,You dont have access for this feature. Please contact admin."

const chartjs = {
  bar: {
    data: {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Expense for this year',
          backgroundColor: '#6a82fb',
          stack: 'Expense',
          data: [10000, 30000, 50000, 80000, 60000, 20000, 10000],
        },
        {
          label: 'Expense for last year',
          backgroundColor: '#fc5c7d',
          stack: 'Expense',
          data: [30000, 80000, 50000, 100000, 60000, 40000, 90000],
        },
      ],
    },
    options: {
      title: {
        display: false,
        text: 'Chart.js Bar Chart - Stacked',
      },
      tooltips: {
        mode: 'index',
        intersect: false,
      },
      responsive: true,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            display: false,
          },
        ],
        yAxes: [
          {
            stacked: true,
            display: false,
          },
        ],
      },
    },
  },
  doughnut: {
    data: {
      datasets: [
        {
          data: [20, 30, 40, 50, 60],
          backgroundColor: [
            '#6a82fb',
            '#fc5c7d',
            '#45b649',
            '#00c9ff',
            '#ffd700',
          ],
          label: 'Dataset 1',
        },
      ],
      labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue'],
    },
    options: {
      responsive: true,
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: 'Chart.js Doughnut Chart',
      },
      animation: {
        animateScale: true,
        animateRotate: true,
      },
    },
  },
  line: {
    data: {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Revenue for this year',
          borderColor: '#6a82fb',
          backgroundColor: '#6a82fb',
          data: [0, 1300, 2200, 3400, 4600, 3500, 3000],
        },

        {
          label: 'Revenue for last year',
          borderColor: '#fc5c7d',
          backgroundColor: '#fc5c7d',
          data: [0, 1300, 2200, 3400, 4600, 3500, 3000],
        },
      ],
    },
    options: {
      responsive: true,
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: 'Chart.js Line Chart - Stacked Area',
      },
      tooltips: {
        intersect: false,
        mode: 'nearest',
      },
      hover: {
        mode: 'index',
      },
      scales: {

      },
    },
  },
};


const Infodata = {
  gstw,
  cinw,
  dinw,
  panw,
  upiw,
  msmew,
  Factbytew,
  Factbyteb,
  mobile360w,
  mobile360d,
  gstb,
  cinb,
  dinb,
  panb,
  upib,
  msmeb,
  deshboardw,
  Profile,
  color,
  iecw,
  madw,
  madb,
  iecb,
  osintb,
  osintw,
  gstStatus,
  CompanyStatus,
  ListingStatus,
  Classification,
  AuthorizedCapital,
  SocialMediaImg,
  PaidUpCapital,
  stateNameMap,
  countChart,
  bankw,
  bankd,
  InfoByApiFichar,
  pdf,
  pdfb, ngow,
  pdfdata,
  chartjs,
  profile,
  drive,
  mca,
  iob, logoloader
};


export default Infodata;
